import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map  } from 'rxjs/operators';
import { Constants } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  constructor(public http: HttpClient) {}

  public id: string = "";
  public baseUrl: String = "";

  getData(url) 
  {
    return this.call('GET', url)
  }

  saveData(url, payload) {
    
    return this.call('POST', url, payload)
  }

  deleteData(url) 
  {
    return this.call('DELETE', url)
  }


  downloadData(url, payload)
  {
    payload.AppVersion = Constants.APP_VERSION;

    return this.callArrayBuffer(url, payload)
  }


  call(method, url, payload?) {

    var requestOptions = { headers: new HttpHeaders().set('id', this.id) }

    if (method === 'POST') 
    {
      if (url.includes('driver/app/view/notice/image')) 
      {
        requestOptions = <any>{ ...requestOptions, responseType: 'text' }
      }
      else if (url.includes('kiosk/plate/image'))
      {
        requestOptions = <any>{ ...requestOptions, responseType: 'text' }
      }
      else if (url == 'payment/receipt' || url == 'driver_portal/gdpr/request/download')
      {
        return this.http.post(`${this.baseUrl}${url}`, JSON.stringify(payload), {responseType: 'arraybuffer'})
           .pipe(map(res => res))
      }

      return this.http.post(`${this.baseUrl}${url}`, JSON.stringify(payload), requestOptions)
        .pipe(map(res => res))
    }
    else if (method === 'GET') 
    {
      return this.http.get(`${this.baseUrl}${url}`, requestOptions)
      .pipe(map(res => res)) 
    }
    else if (method === 'DELETE') 
    {
      return this.http.delete(`${this.baseUrl}${url}`, requestOptions)
        .pipe(map(res => res))
    }
  }


  callArrayBuffer(url, payload?) {

    var requestOptions = { headers: new HttpHeaders().set('id', this.id) }
    requestOptions = <any>{ ...requestOptions, responseType: 'arraybuffer' }

    return this.http.post(`${this.baseUrl}${url}`, JSON.stringify(payload), requestOptions)
      .pipe(map(res => res))
    
  }
}
